import axios from "axios";
import { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { AddButton, SubTitle } from "../../Components/CustomComponents";
import DeleteModal from "../../Components/Modals/DeleteModal";
import EditUserModal from "../../Components/Modals/EditUserModal";
import Table from "../../Components/Table/Table";
import Toast from "../../Hooks/useToast";
import styles from "./styles/index.module.scss";
import { ImCross } from "react-icons/im";
// import { ToastContainer, toast } from "react-toastify";

//
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
import { updateUsers } from "../../Data/features/userSlice";
import {
  useBlockUnblockUserMutation,
  useChangeUserPassMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,
} from "../../Data/services/userApi"; // get data from API Servers
import ChangePasswordModal from "../../Components/Modals/changePassModal";
import ModalImage from "react-modal-image";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import { AiOutlineSearch } from "react-icons/ai";
import { Controller, useForm } from "react-hook-form";
import {
  useBlockUnblockContentMutation,
  useGetAllContentQuery,
} from "../../Data/services/contentApi";
import ViewModal from "../../Components/Modals/ViewModal";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { FaCross } from "react-icons/fa6";

const ContentManagement = ({ setPage }) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      searchText: "", // or any sensible default
    },
  });
  const dispatch = useDispatch();
  const searchText = watch("searchText");
  console.log(searchText, "searchText");

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [waterMarkModal, setWaterMarkModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [currentPage, setCurrentPage] = useState(1); // todo
  const [filter, setFilter] = useState("CREATOR");
  const [blockModal, setBlockModal] = useState(false);
  const [changePassModal, setChangePassModal] = useState(false);
  const skipQuery =
    searchText === undefined ||
    pageSize === undefined ||
    currentPage === undefined;

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllContentQuery(
      {
        limit: pageSize,
        page: currentPage,
        search: searchText,
      },
      { refetchOnMountOrArgChange: true }
    );
  const [
    blockUnblockContent,
    {
      isSuccess: isSuccessBlock,
      isLoading: isLoadingBlock,
      isError: isErrorBlock,
    },
  ] = useBlockUnblockContentMutation();

  console.log(data?.links, "pppp");

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data?.links?.per_page);
      setCurrentPage(data?.links?.current);
      setTotalRecords(data?.links?.total_records);
      setTotalPages(data?.links?.total);
      setRowData(data?.data);
    }
    if (data?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [data]);

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "media",
      text: "Image",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => {
        return (
          <video width="200" height="150" controls>
            <source src={row?.media_url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      },
    },
    {
      dataField: "watermark",
      text: "Watermark",
      // sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return (
          <div
            className="lc-1 cursor-pointer"
            onClick={() => {
              setEditedData(row);
              setWaterMarkModal(true);
            }}
          >
            {row?.watermark}
          </div>
        );
      },
    },

    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return <div className="">{row?.title}</div>;
      },
    },
    {
      dataField: "username",
      text: "Name",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return `${row?.user?.firstname} ${row?.user?.lastname}`;
      },
    },
    {
      dataField: "username",
      text: "Published",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return row?.is_published == 1 ? (
          <IoIosCheckmarkCircle color="green" />
        ) : (
          <ImCross color="red" />
        );
      },
    },

    {
      dataField: "username",
      text: "Likes",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return row?.total_likes;
      },
    },

    {
      dataField: "username",
      text: "Views",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return row?.total_views;
      },
    },

    {
      dataField: "username",
      text: "Comments",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return `${row?.total_comments}`;
      },
    },

    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return (
          <div
            className="lc-1 cursor-pointer"
            onClick={() => {
              setEditedData(row);
              setViewModal(true);
            }}
          >
            {row?.description}
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) =>
        row?.is_blocked ? (
          <div className={styles.block}>Block</div>
        ) : (
          <div className={styles.active}> Active </div>
        ),
    },

    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "200px",
    //   },
    //   formatter: (cellContent, row) => {
    //     // console.log(row)
    //     if (row.id) {
    //       return (
    //         <div className="d-flex justify-content-center align-items-center ">
    //           <div
    //             className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 `}
    //             role="button"
    //             onClick={() => {
    //               setEditedData(row);
    //               handleEditModalOpen(true);
    //             }}
    //           >
    //             <span
    //               className={`align-items-center d-flex justify-content-center pe-1 `}
    //             >
    //               <FaUserEdit />
    //             </span>
    //             <span>Edit</span>
    //           </div>
    //           <div
    //             className="d-flex justify-content-center align-items-center bg-danger rounded-3 p-2 mx-2 "
    //             role="button"
    //             onClick={() => {
    //               setEditedData(row);
    //               handleDeleteModalOpen();
    //             }}
    //           >
    //             <span className={`d-flex align-items-center pe-1`}>
    //               <MdDeleteForever />
    //             </span>
    //             <span>Delete</span>
    //           </div>
    //         </div>
    //       );
    //     }
    //   },
    // },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <Dropdown className={`d-inline mx-2 ${styles.choice}`}>
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="primary-btn"
                >
                  {/* <IoEllipsisVertical /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setBlockModal(true);
                    }}
                  >
                    {row?.is_blocked === true ? "UnBlock" : "Block"}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        }
      },
    },
  ];
  const handleBlockModalClose = () => {
    setBlockModal(false);
    setEditedData("");
  };

  const blockUnblockSubmit = async () => {
    let response;
    try {
      response = await blockUnblockContent(editedData?.id).unwrap();

      Toast(response?.message, "success");
      setBlockModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  return (
    <div className={styles.MainContainer}>
      {blockModal ? (
        <DeleteModal
          handleDeleteModalClose={handleBlockModalClose}
          data={editedData}
          cnfrmtext={
            editedData?.is_blocked === true ? "Unblock User" : "Block User"
          }
          text={editedData?.is_blocked === true ? "Unblock" : "Block"}
          cnfrm={isLoadingBlock ? <LoadingButton /> : "Confirm"}
          cancel={"Cancel"}
          onDelete={blockUnblockSubmit}
        />
      ) : (
        ""
      )}
      {editModal ? (
        <EditUserModal
          handleEditModalClose={handleEditModalClose}
          data={editedData}
        />
      ) : (
        ""
      )}
      {viewModal ? (
        <ViewModal
          handleEditModalClose={() => setViewModal(false)}
          data={editedData?.description}
          cnfrmtext={"Description"}
        />
      ) : (
        ""
      )}

      {waterMarkModal ? (
        <ViewModal
          handleEditModalClose={() => setWaterMarkModal(false)}
          data={editedData?.watermark}
          cnfrmtext={"Watermark"}
        />
      ) : (
        ""
      )}
      <div className={styles.headerContainer}>
        <div className="w-100 flex-between">
          <SubTitle text={"Content Management"} />
          <div className="d-flex gap-5">
            <div className={styles.search}>
              <div className={styles.searchButton}>
                <AiOutlineSearch color="black" />
              </div>
              <Controller
                control={control}
                name="searchText"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value || ""} // Ensure empty string fallback
                    ref={ref}
                  />
                )}
              />
            </div>
          </div>
        </div>
        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {<Table data={rowData} columns={columns} indication={indication} />}
      </div>
    </div>
  );
};

export default ContentManagement;
